<template>
  <div>
    <v-simple-table class="spending-table nav-table">
      <template v-slot:default>
        <thead>
          <tr class="primary">
            <th width="42px" style="padding: 0px 17px !important;">
              <v-layout align-center>
                <label class="form-checkbox">
                  <input
                    type="checkbox"
                    class="checkbox-approval"
                    v-model="items[selectedAllName]"
                    @click="selectAll(items)"
                  />
                  <span class="checkbox-custom"></span>
                </label>
              </v-layout>
              <!-- <label class="form-checkbox">
                <input
                  class="checkbox-approval"
                  type="checkbox"
                  v-model="items[selectedAllName]"
                  @click="selectAll(items)"
                />
                <span class="checkbox-custom"> </span>
              </label> -->
            </th>
            <th rowspan="2" class="f-14 text-capitalize">{{ text }} Name</th>
            <th rowspan="2" class="f-14">
              Total Budget
            </th>
            <th rowspan="2" class="f-14">
              Total Spending
            </th>
            <th rowspan="2" class="f-14">
              Total Remaining
            </th>
            <th class="f-14" width="10%">
              Notes
            </th>
          </tr>
        </thead>
        <v-perfect-scroll
          class="drawer-menu--scroll"
          :settings="scrollSettings"
        >
          <tbody v-if="itemParts.length > 0">
            <tr
              v-for="house in itemParts"
              :key="house.id"
              style="cursor:pointer;"
              :class="bgStatus(house.status)"
            >
              <td width="41px">
                <v-layout align-center>
                  <label class="form-checkbox">
                    <input
                      class="checkbox-approval"
                      type="checkbox"
                      :value="house.id"
                      v-model="items[selectedName]"
                      @click="
                        checkSelect(items, selectedName, title, selectedAllName)
                      "
                    />
                    <span class="checkbox-custom"> </span>
                  </label>
                </v-layout>
              </td>
              <td
                :class="bgActive(items[activeName], house.id)"
                @click="getDetailApproval(house, items)"
              >
                {{ house.name }}
              </td>
              <td
                class="text-right"
                :class="bgActive(items[activeName], house.id)"
                @click="getDetailApproval(house, items)"
              >
                {{ idr(house.totalBudget) }}
              </td>
              <td
                class="text-right"
                :class="bgActive(items[activeName], house.id)"
                @click="getDetailApproval(house, items)"
              >
                {{ idr(house.totalSpending) }}
              </td>
              <td
                class="text-right"
                :class="bgActive(items[activeName], house.id)"
                @click="getDetailApproval(house, items)"
              >
                {{ idr(house.remaining) }}
              </td>
              <td width="10%" class="text-center">
                <v-btn
                  x-small
                  class="ma-2"
                  text
                  icon
                  color="secondblue"
                  @click="modalNotes(house, items, title)"
                >
                  <v-icon x-small>
                    mdi-square-edit-outline
                  </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4" class="text-center pt-2">
                <span>No Data Displayed</span>
              </td>
            </tr>
          </tbody>
        </v-perfect-scroll>
      </template>
    </v-simple-table>
    <v-flex xs12 class="text-right px-2 pr-0">
      <v-btn
        class="ma-2 white--text"
        color="#bd1e19"
        :disabled="items[selectedName].length < 1"
        @click="confirmRejectHouseDept(items, title, text)"
      >
        Reject
      </v-btn>
      <v-btn
        primary
        class="primary ma-2 mr-0"
        :disabled="items[selectedName].length < 1"
        @click="confirmApproveHouseDept(items, title, text)"
      >
        Approve
      </v-btn>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      required: false
    },
    itemPart: {
      type: Array,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      items: {},
      itemParts: [],
      scrollSettings: {
        maxScrollbarLength: 260
      }
    };
  },
  mounted() {
    this.items = this.itemData;
    this.itemParts = this.itemPart;
  },
  watch: {
    itemData(val) {
      this.items = val;
    },
    itemPart(val) {
      this.itemParts = val;
    }
  },
  computed: {
    selectedAllName() {
      let name = '';
      switch (this.title) {
        case 'house':
          name = 'selectAllHouse';
          break;
        case 'dept':
          name = 'selectAllDept';
          break;
        case 'budgetowner':
          name = 'selectAllBO';
          break;
      }
      return name;
    },
    selectedName() {
      let name = '';
      switch (this.title) {
        case 'house':
          name = 'houseSelected';
          break;
        case 'dept':
          name = 'deptSelected';
          break;
        case 'budgetowner':
          name = 'BOselected';
          break;
      }
      return name;
    },
    activeName() {
      let name = '';
      switch (this.title) {
        case 'house':
          name = 'houseActive';
          break;
        case 'dept':
          name = 'deptActive';
          break;
        case 'budgetowner':
          name = 'boActive';
          break;
      }
      return name;
    }
  },
  methods: {
    selectAll(item) {
      this.$emit('selectAll', item);
    },
    checkSelect(item, selectedItem, items, itemSelectAll) {
      // kalau setelah select all di table terus ada yang di uncheck di list nya yang select all jadi false
      if (item[itemSelectAll]) {
        if (item[selectedItem].length !== item[items].length) {
          item[itemSelectAll] = true;
        } else {
          item[itemSelectAll] = false;
        }
      }
    },
    // this.$emit('checkSelect', {
    //   item: items,
    //   selectedItem: selectedName,
    //   items: title,
    //   itemSelectAll: selectedAllName
    // });
    getDetailApproval(house, items) {
      this.$emit('getDetailApproval', {
        item: house,
        itemParent: items
      });
    },
    modalNotes(house, items, title) {
      this.$emit('modalNotes', {
        item: house,
        parentItem: items,
        name: title
      });
    },
    confirmApproveHouseDept(item, type, text) {
      this.$emit('confirmApproveHouseDept', {
        item: item,
        type: type,
        text: text
      });
    },
    confirmRejectHouseDept(item, type, text) {
      this.$emit('confirmRejectHouseDept', {
        item: item,
        type: type,
        text: text
      });
    },
    bgActive(val1, val2) {
      if (val1 == val2) {
        return 'primary--text';
      } else {
        return '';
      }
    }
  }
};
</script>
